import { render, staticRenderFns } from "./BasePageContainer.vue?vue&type=template&id=c2dda012"
import script from "./BasePageContainer.vue?vue&type=script&lang=ts"
export * from "./BasePageContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports